<template lang="pug">
  app-modal.modalModelo(
    @closeModal="$emit('closeModal')"
    titulo="Adicionar modelo"
  )
    template(slot="body")
      validation-observer(ref='validation' tag='form')
        .group(v-if="hasPermissaoNotificar || exibirTitulo || exibirDespachoReurb || exibirDespacho || exibirModeloRegistroImovel || exibirJustificativa || exibirModeloExtratoSentenca")
          p.required Selecione qual tipo de modelo deseja adicionar:
          validation-provider(rules="required", v-slot="{ errors }")
            el-radio.input(v-if="exibirDespacho" :label="1" v-model="modelo.tipoModelo",:class="{'erro' : errors.length}") Modelo de despacho
            el-radio.input(v-if="hasPermissaoNotificar" :label="2" v-model="modelo.tipoModelo",:class="{'erro' : errors.length}") Modelo de notificação
            el-radio.input(v-if="exibirTitulo", :label="3" v-model="modelo.tipoModelo",:class="{'erro' : errors.length}") Modelo do título
            el-radio.input(v-if="exibirDespachoReurb && isMaranhao", :label="4" v-model="modelo.tipoModelo",:class="{'erro' : errors.length}") Modelo de despacho dinâmico
            el-radio.input(v-if="exibirDespachoReurb && !isMaranhao", :label="4" v-model="modelo.tipoModelo",:class="{'erro' : errors.length}") Modelo de despacho
            el-radio.input(v-if="exibirModeloRegistroImovel && !isMaranhao", :label="5" v-model="modelo.tipoModelo",:class="{'erro' : errors.length}") Modelo de registro de imóvel
            el-radio.input(v-if="exibirDespachoVistoria", :label="6" v-model="modelo.tipoModelo",:class="{'erro' : errors.length}") Modelo app vistoria
            el-radio.input(v-if="exibirModeloExtratoSentenca", :label="8" v-model="modelo.tipoModelo",:class="{'erro' : errors.length}") Modelo extrato de sentença dinâmico
            el-radio.input(v-if="exibirModeloJustificativa && (isMaranhao || isAmapa)", :label="7" v-model="modelo.tipoModelo",:class="{'erro' : errors.length}") Modelo justificativa
        .group(v-else)
          p Adicionar um modelo de despacho
        .group.mt-1
          p.required {{getLabelDescricaoTexto(modelo.tipoModelo)}}:
          validation-provider(rules="required", v-slot="{ errors }")
            el-input.input(v-model="modelo.descricaoTexto",:class="{'erro' : errors.length}")
        .group.mt-1
          div
            .flex
              p.required {{getLabelTextoModelo(modelo.tipoModelo)}}:
              el-tooltip(
                v-if="modelo.tipoModelo === 2 && !isMaranhao && !isAmapa && !isBahia && modelo.tipoModelo !== 6"
                effect='dark',
                placement='top',
                class="tooltip"
              )
                template(slot="content")
                  span Para criar um modelo com o nome do interessado, número do processo,<br>
                  span e/ou outros dados do processo, utilize conforme exemplos abaixo:<br>
                  li Processo nº &lt;numero_processo&gt;<br>
                  li Interessado &lt;nome_interessado&gt;<br>
                  li Município &lt;municipio&gt;<br>
                  li Data emissão &lt;data_emissao&gt; <br>
                  li Município emissor &lt;municipio_emissor&gt <br>
                  li Local emissão &lt;local_emissao&gt <br>
                  li Área georreferenciamento &lt;area_georreferenciamento&gt <br>
                  li Área &lt;area&gt <br>
                  li Perfil emissor &lt;perfil_emissor&gt <br>
                  li Nome do emissor &lt;nome_emissor&gt <br>
                  li Número da notificação &lt;numero_notificacao&gt <br>
                  li CPF do interessado  &lt;cpf_interessado&gt <br>
                  li RG do interessado  &lt;rg_interessado&gt <br>
                i.el-icon-info.icon-info
              el-tooltip(
                v-if="(modelo.tipoModelo === 4 || modelo.tipoModelo === 5) && !isAmapa && !isBahia"
                effect='dark',
                placement='top',
                class="tooltip"
              )
                template(slot="content")
                  span Para criar um modelo de despacho com o nome do interessado, número do processo,<br>
                  span e/ou outros dados do processo, utilize conforme exemplos abaixo:<br>
                  li Processo nº &lt;numero_processo&gt;<br>
                  li Interessado &lt;nome_interessado&gt;<br>
                  li Município &lt;municipio&gt;<br>
                  li Bairro &lt;bairro&gt; <br>
                  li Dia &lt;dia&gt <br>
                  li Mês &lt;mes&gt <br>
                  li Ano &lt;ano&gt <br>
                  li Município emissor &lt;municipio_emissor&gt <br>
                  li Área &lt;area_georreferenciamento&gt <br>
                  li Perfil emissor &lt;perfil_emissor&gt <br>
                  li Nome do emissor &lt;nome_emissor&gt <br>
                  li CPF do interessado  &lt;cpf_interessado&gt <br>
                  li RG do interessado  &lt;rg_interessado&gt <br>
                i.el-icon-info.icon-info
              el-tooltip(
                v-if="(isAmapa || isBahia) && modelo.tipoModelo === 4"
                effect='dark',
                placement='top',
                class="tooltip"
              )
                template(slot="content")
                  span Para criar um modelo de despacho com o nome do interessado, número do processo,<br>
                  span e/ou outros dados do processo, utilize conforme exemplos abaixo:<br>
                  li Processo nº &lt;numero_processo&gt;<br>
                  li Interessado &lt;nome_interessado&gt;<br>
                  li Município &lt;municipio&gt;<br>
                  li Bairro &lt;bairro&gt; <br>
                  li Dia &lt;dia&gt; <br>
                  li Mês &lt;mes&gt; <br>
                  li Ano &lt;ano&gt; <br>
                  li Município emissor &lt;municipio_emissor&gt; <br>
                  li Área &lt;area_georreferenciamento&gt; <br>
                  li Perfil emissor &lt;perfil_emissor&gt; <br>
                  li Nome do emissor &lt;nome_emissor&gt; <br>
                  li CPF do interessado &lt;cpf_interessado&gt; <br>
                  li RG do interessado &lt;rg_interessado&gt; <br>
                i.el-icon-info.icon-info
              el-tooltip(
                v-if="(isAmapa || isBahia ) && (modelo.tipoModelo === 2 || modelo.tipoModelo == 7)"
                effect='dark',
                placement='top',
                class="tooltip"
              )
                template(slot="content")
                  span Para criar um modelo de notificação com o nome do interessado, número do processo,<br>
                  span e/ou outros dados do processo, utilize conforme exemplos abaixo:<br>
                  li Processo nº &lt;numero_processo&gt;<br>
                  li Interessado &lt;nome_interessado&gt;<br>
                  li Município &lt;municipio&gt;<br>
                  li Bairro &lt;bairro&gt; <br>
                  li Dia &lt;dia&gt; <br>
                  li Mês &lt;mes&gt; <br>
                  li Ano &lt;ano&gt; <br>
                  li Município emissor &lt;municipio_emissor&gt; <br>
                  li Área &lt;area_georreferenciamento&gt; <br>
                  li Perfil emissor &lt;perfil_emissor&gt; <br>
                  li Nome do emissor &lt;nome_emissor&gt; <br>
                  li CPF do interessado &lt;cpf_interessado&gt; <br>
                  li RG do interessado &lt;rg_interessado&gt; <br>
                i.el-icon-info.icon-info
              el-tooltip(
                v-if="modelo.tipoModelo === 8"
                effect='dark',
                placement='top',
                class="tooltip"
              )
                template(slot="content")
                  span Para criar um modelo de extrato de sentença, utilize conforme exemplos abaixo:<br>
                  li Nº extrato de sentença &lt;numero_extrato_sentenca&gt;<br>
                  li Nº processo Interessado municipio &lt;numero_processo_nome_interessado_municipio&gt;<br>
                i.el-icon-info.icon-info
            div
              validation-provider(rules="required", v-slot="{ errors }")
                app-editor-texto(:value="modelo.textoModelo", @onTextChange="onTextChange",:class="{'erro' : errors.length}")
    template(slot="footer")
      .flex-between
        el-button(@click="$emit('closeModal')") Cancelar &nbsp
          .fa.fa-times
        salvar-modelo(v-model="saveModelo" @update:modelValue="saveModelo($event)")

</template>

<script>
import AppModal from '@/components/AppModal'
import AppLabel from '@/components/AppLabel'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import AppEditorTexto from '@/components/AppEditorTexto'
import AppAnexo from '@/components/AppAnexo'
import SalvarModelo from './SalvarModelo.vue'
import { mapActions, mapGetters } from 'vuex'
const { hasPermissaoNotificar, cadastro, separatorByUnderscore, defaultModeloDespacho } = require('@/utils/' + process.env.ESTADO + '/regrasAnalise').default

export default {

  components: {
    AppModal,
    AppLabel,
    AppEditorTexto,
    AppAnexo,
    SalvarModelo
  },

  mixins: [
    AppNotificacao
  ],

  data () {
    return {
      modelo: {
        tipoModelo: this.tipoModeloSwitcher,
        descricaoTexto: '',
        textoModelo: ''
      },
      anexos: [],
      showUpload: true,
      errorsAnexo: []
    }
  },
  beforeMount () {
    this.modelo.tipoModelo = this.tipoModeloSwitcher
  },
  computed: {
    ...mapGetters({
      usuario: 'auth/usuarioLogado'
    }),
    /**
     * <b> Retorna o id selecionado de cada radio button </b> </br>
     * 4 para despacho dinâmico </br>
     * 2 para notificação do interessado dinâmico </br>
     * 1 para despacho normal (antigo) </br>
     * @author Gabriel N.
     */
    tipoModeloSwitcher () {
      if (this.isMaranhao) {
        return this.isNotAllowed() && defaultModeloDespacho
      }
      return this.isNotAllowed() && hasPermissaoNotificar.PERFIS_PERMITIDOS.includes(separatorByUnderscore(this.usuario.perfilSelecionado.codigo)) ? 2 : defaultModeloDespacho
    },
    hasPermissaoNotificar () {
      if (this.isAmapa || this.isBahia) {
        return this.isNotAllowed() && hasPermissaoNotificar.PERFIS_PERMITIDOS.includes(this.usuario.perfilSelecionado.codigo)
      }
      return (this.isNotAllowed() && hasPermissaoNotificar.PERFIS_PERMITIDOS.includes(separatorByUnderscore(this.usuario.perfilSelecionado.codigo))) ||
        this.isMaranhao
    },
    exibirTitulo () {
      return cadastro.exibirModeloTitulo && cadastro.perfisModeloTitulo.perfis.includes(this.usuario.perfilSelecionado.codigo)
    },
    exibirDespachoReurb () {
      return cadastro.exibirModeloDespachoReurb && cadastro.perfisModeloDespachoReurb.perfis.includes(this.usuario.perfilSelecionado.codigo)
    },
    exibirDespachoVistoria () {
      return cadastro.exibirModeloDespachoVistoria && cadastro.perfisModeloDespachoVistoria.perfis.includes(this.usuario.perfilSelecionado.codigo)
    },
    exibirModeloRegistroImovel () {
      return cadastro.exibirModeloRegistroImovel && cadastro.perfisModeloRegistroImovel.perfis.includes(this.usuario.perfilSelecionado.codigo)
    },
    exibirDespacho () {
      return cadastro.exibirModeloDespacho
    },
    exibirModeloJustificativa () {
      return cadastro.exibirModeloJustificativa && cadastro.perfisModeloJustificativa.perfis.includes(this.usuario.perfilSelecionado.codigo)
    },
    exibirModeloExtratoSentenca () {
      return cadastro.exibirModeloExtratoSentenca && cadastro.perfisModeloExtratoSentenca.perfis.includes(this.usuario.perfilSelecionado.codigo)
    },
    isMaranhao () {
      return process.env.ESTADO === 'ma'
    },
    isAmapa () {
      return process.env.ESTADO === 'ap'
    },
    isBahia () {
      return process.env.ESTADO === 'ba'
    }
  },

  methods: {
    ...mapActions({
      salvarModeloDespacho: 'modeloDespacho/salvarModeloDespacho'
    }),
    onTextChange (value) {
      this.modelo.textoModelo = value
    },
    getLabelDescricaoTexto (tipo) {
      switch (tipo) {
        case 2:
          return 'Descrição da Notificação'
        case 3:
          return 'Descrição do Título'
        case 5:
          return 'Descrição do Registro de Imóvel'
        case 7:
          return 'Descrição Justificativa'
        case 8:
          return 'Descrição do Extrato de Sentença'
        default:
          return 'Descrição do Despacho'
      }
    },
    getLabelTextoModelo (tipo) {
      switch (tipo) {
        case 2:
          return 'Notificação'
        case 3:
          return 'Título'
        case 5:
          return 'Registro de Imóvel'
        case 7:
          return 'Justificativa'
        case 8:
          return 'Extrato de Sentença'
        default:
          return 'Despacho'
      }
    },
    /**
     * Perfis que não podem ter o modelo de notificação (Notificação dinãmica)
     * @returns {boolean}
     * @author Gabriel N.
     */
    isNotAllowed () {
      return !(this.usuario.perfilSelecionado.codigo === 'GOVERNADOR' || this.usuario.perfilSelecionado.codigo === 'PRESIDENTE_GP')
    },
    async saveModelo ($event) {
      // se for Despacho REURB
      if (await this.$refs.validation.validate() && $event) {
        this.salvarModeloDespacho(this.modelo).then(() => {
          this.$emit('closeModal')
          this.$emit('updateAoAdicionar', { campoSimples: '' })
          this.showNotificacao(this.$messages.TIPO_SUCCESS, this.$messages.TITULO_SUCCESS,
            'Modelo salvo com sucesso!')
        })
      }
    }
  }
}

</script>

<style scoped lang="scss">

.group p.required:after {
    color: red;
    content: " *";
}

.flex {
  display: flex;
  align-items: baseline;
}

.tooltip {
  margin-left: 5px;
  color: black;
}

.flex-between {
  display: flex;
  justify-content: space-between;
}

/deep/ .el-button span {
  display: flex;
  font-size: 16px;
}

.erro {
  border: solid 1px red;
  border-radius: 5px;
}

@media (max-width: 780px) {
  .modalModelo {
    position: fixed !important;
    width: 395px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/components/AppModalAdicionarModelo.vue